import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function Products() {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All Products', icon: 'ri-grid-line' },
    { id: 'bathroom', name: 'Bathroom Sanitary', icon: 'ri-drop-line' },
    { id: 'toilet', name: 'Toilet Items', icon: 'ri-home-4-line' },
    { id: 'kitchen', name: 'Kitchen Items', icon: 'ri-restaurant-line' },
    { id: 'pipes', name: 'Pipes & Fittings', icon: 'ri-tools-line' },
    { id: 'hardware', name: 'Hardware Tools', icon: 'ri-hammer-line' }
  ];

  const products = [
    // Bathroom Sanitary
    {
      category: 'bathroom',
      name: 'Premium Chrome Taps',
      description: 'High-quality chrome-plated bathroom taps with modern design',
      features: ['Durable chrome finish', 'Easy installation', 'Water-efficient'],
      image: 'https://public.readdy.ai/ai/img_res/29acd0c09556c129977f14160744a3a4.jpg'
    },
    {
      category: 'bathroom',
      name: 'Luxury Shower Set',
      description: 'Complete shower system with overhead and hand shower',
      features: ['Rainfall shower head', 'Adjustable hand shower', 'Premium quality'],
      image: 'https://readdy.ai/api/search-image?query=luxury%20chrome%20shower%20set%20with%20rainfall%20head%20and%20handheld%20shower%2C%20professional%20product%20photography%20on%20white%20background%2C%20modern%20bathroom%20fixture%2C%20high%20quality%20sanitary%20ware%2C%20studio%20lighting&width=500&height=500&seq=prod2&orientation=squarish'
    },
    {
      category: 'bathroom',
      name: 'Mixing Wall Faucet',
      description: 'Wall-mounted mixer with hot and cold water control',
      features: ['Temperature control', 'Wall-mounted design', 'Chrome finish'],
      image: 'https://readdy.ai/api/search-image?query=modern%20wall%20mounted%20bathroom%20mixer%20faucet%20with%20chrome%20finish%2C%20professional%20product%20photography%20on%20clean%20white%20background%2C%20high%20quality%20sanitary%20fixture%2C%20minimalist%20design%2C%20studio%20lighting&width=500&height=500&seq=prod3&orientation=squarish'
    },
    {
      category: 'bathroom',
      name: 'Basin Mixer Tap',
      description: 'Elegant basin mixer for wash basins',
      features: ['Single lever control', 'Smooth operation', 'Modern design'],
      image: 'https://readdy.ai/api/search-image?query=elegant%20chrome%20basin%20mixer%20tap%20with%20single%20lever%2C%20professional%20product%20photography%20on%20white%20background%2C%20modern%20bathroom%20faucet%2C%20high%20quality%20sanitary%20ware%2C%20studio%20lighting&width=500&height=500&seq=prod4&orientation=squarish'
    },
    {
      category: 'bathroom',
      name: 'Shower Cabin Complete',
      description: 'Glass shower enclosure with all accessories',
      features: ['Tempered glass', 'Complete installation kit', 'Modern design'],
      image: 'https://readdy.ai/api/search-image?query=modern%20glass%20shower%20cabin%20enclosure%20with%20chrome%20frame%20and%20fixtures%2C%20professional%20product%20photography%20on%20white%20background%2C%20complete%20bathroom%20shower%20system%2C%20high%20quality%2C%20studio%20lighting&width=500&height=500&seq=prod5&orientation=squarish'
    },
    {
      category: 'bathroom',
      name: 'Shower Accessories Set',
      description: 'Complete bathroom accessories including soap holder, towel rod',
      features: ['Chrome finish', 'Complete set', 'Easy installation'],
      image: 'https://readdy.ai/api/search-image?query=chrome%20bathroom%20accessories%20set%20including%20towel%20rod%20soap%20holder%20and%20hooks%2C%20professional%20product%20photography%20on%20white%20background%2C%20modern%20sanitary%20accessories%2C%20studio%20lighting&width=500&height=500&seq=prod6&orientation=squarish'
    },

    // Toilet Items
    {
      category: 'toilet',
      name: 'Premium WC Seat',
      description: 'Comfortable and durable toilet seat',
      features: ['Soft-close mechanism', 'Easy to clean', 'Universal fit'],
      image: 'https://readdy.ai/api/search-image?query=white%20premium%20toilet%20seat%20with%20soft%20close%20mechanism%2C%20professional%20product%20photography%20on%20clean%20background%2C%20modern%20bathroom%20fixture%2C%20high%20quality%20sanitary%20ware%2C%20studio%20lighting&width=500&height=500&seq=prod7&orientation=squarish'
    },
    {
      category: 'toilet',
      name: 'Low Odor WC Seat',
      description: 'Special odor-resistant toilet seat',
      features: ['Odor control technology', 'Antibacterial surface', 'Durable material'],
      image: 'https://readdy.ai/api/search-image?query=modern%20white%20toilet%20seat%20with%20antibacterial%20coating%2C%20professional%20product%20photography%20on%20white%20background%2C%20premium%20bathroom%20fixture%2C%20high%20quality%20sanitary%20product%2C%20studio%20lighting&width=500&height=500&seq=prod8&orientation=squarish'
    },
    {
      category: 'toilet',
      name: 'Flush Tank Complete',
      description: 'High-quality flush tank with dual flush system',
      features: ['Water-saving dual flush', 'Durable construction', 'Easy installation'],
      image: 'https://readdy.ai/api/search-image?query=white%20ceramic%20flush%20tank%20with%20dual%20flush%20buttons%2C%20professional%20product%20photography%20on%20clean%20background%2C%20modern%20toilet%20cistern%2C%20high%20quality%20sanitary%20ware%2C%20studio%20lighting&width=500&height=500&seq=prod9&orientation=squarish'
    },
    {
      category: 'toilet',
      name: 'Jet Spray Set',
      description: 'Stainless steel health faucet with holder',
      features: ['Stainless steel construction', 'Wall-mounted holder', 'Flexible hose'],
      image: 'https://readdy.ai/api/search-image?query=chrome%20jet%20spray%20health%20faucet%20with%20wall%20holder%20and%20flexible%20hose%2C%20professional%20product%20photography%20on%20white%20background%2C%20bathroom%20bidet%20spray%2C%20high%20quality%20fixture%2C%20studio%20lighting&width=500&height=500&seq=prod10&orientation=squarish'
    },
    {
      category: 'toilet',
      name: 'Toilet Fittings Kit',
      description: 'Complete set of toilet installation fittings',
      features: ['All necessary fittings', 'High-quality materials', 'Easy installation'],
      image: 'https://readdy.ai/api/search-image?query=toilet%20installation%20fittings%20kit%20with%20bolts%20nuts%20and%20washers%2C%20professional%20product%20photography%20on%20white%20background%2C%20plumbing%20hardware%20accessories%2C%20studio%20lighting&width=500&height=500&seq=prod11&orientation=squarish'
    },

    // Kitchen Items
    {
      category: 'kitchen',
      name: 'Stainless Steel Kitchen Sink',
      description: 'Premium quality single bowl kitchen sink',
      features: ['304 stainless steel', 'Rust-resistant', 'Easy to clean'],
      image: 'https://readdy.ai/api/search-image?query=modern%20stainless%20steel%20kitchen%20sink%20single%20bowl%20with%20drain%2C%20professional%20product%20photography%20on%20white%20background%2C%20high%20quality%20kitchen%20fixture%2C%20minimalist%20design%2C%20studio%20lighting&width=500&height=500&seq=prod12&orientation=squarish'
    },
    {
      category: 'kitchen',
      name: 'Double Bowl Kitchen Sink',
      description: 'Large double bowl sink for modern kitchens',
      features: ['Two compartments', 'Heavy-duty construction', 'Professional grade'],
      image: 'https://readdy.ai/api/search-image?query=stainless%20steel%20double%20bowl%20kitchen%20sink%20with%20drains%2C%20professional%20product%20photography%20on%20white%20background%2C%20modern%20kitchen%20fixture%2C%20high%20quality%2C%20studio%20lighting&width=500&height=500&seq=prod13&orientation=squarish'
    },
    {
      category: 'kitchen',
      name: 'Kitchen Faucet Chrome',
      description: 'Modern kitchen tap with swivel spout',
      features: ['360-degree rotation', 'Chrome finish', 'Easy installation'],
      image: 'https://readdy.ai/api/search-image?query=modern%20chrome%20kitchen%20faucet%20with%20swivel%20spout%2C%20professional%20product%20photography%20on%20white%20background%2C%20high%20quality%20kitchen%20tap%2C%20minimalist%20design%2C%20studio%20lighting&width=500&height=500&seq=prod14&orientation=squarish'
    },
    {
      category: 'kitchen',
      name: 'Kitchen Mixer Tap',
      description: 'Hot and cold water mixer for kitchen',
      features: ['Temperature control', 'Durable construction', 'Modern design'],
      image: 'https://readdy.ai/api/search-image?query=modern%20kitchen%20mixer%20tap%20with%20single%20lever%20control%2C%20professional%20product%20photography%20on%20white%20background%2C%20chrome%20kitchen%20faucet%2C%20high%20quality%20fixture%2C%20studio%20lighting&width=500&height=500&seq=prod15&orientation=squarish'
    },
    {
      category: 'kitchen',
      name: 'Filter Nozzle Tap',
      description: 'Kitchen tap with built-in water filter',
      features: ['Water filtration', 'Pure drinking water', 'Easy filter replacement'],
      image: 'https://readdy.ai/api/search-image?query=modern%20kitchen%20faucet%20with%20filter%20nozzle%20attachment%2C%20professional%20product%20photography%20on%20white%20background%2C%20water%20filter%20tap%2C%20high%20quality%20kitchen%20fixture%2C%20studio%20lighting&width=500&height=500&seq=prod16&orientation=squarish'
    },
    {
      category: 'kitchen',
      name: 'Kitchen Accessories Set',
      description: 'Complete kitchen sink accessories',
      features: ['Soap dispenser', 'Drain basket', 'All fittings included'],
      image: 'https://readdy.ai/api/search-image?query=kitchen%20sink%20accessories%20set%20including%20soap%20dispenser%20and%20drain%20basket%2C%20professional%20product%20photography%20on%20white%20background%2C%20stainless%20steel%20kitchen%20accessories%2C%20studio%20lighting&width=500&height=500&seq=prod17&orientation=squarish'
    },

    // Pipes and Fittings
    {
      category: 'pipes',
      name: 'UPVC Pipes Set',
      description: 'High-quality UPVC pipes for plumbing',
      features: ['Corrosion-resistant', 'Long-lasting', 'Various sizes available'],
      image: 'https://readdy.ai/api/search-image?query=white%20UPVC%20plumbing%20pipes%20in%20various%20sizes%20arranged%20neatly%2C%20professional%20product%20photography%20on%20clean%20background%2C%20high%20quality%20plumbing%20materials%2C%20studio%20lighting&width=500&height=500&seq=prod18&orientation=squarish'
    },
    {
      category: 'pipes',
      name: 'PPRC Pipes',
      description: 'Premium PPRC pipes for hot and cold water',
      features: ['Heat-resistant', 'Durable', 'Food-grade material'],
      image: 'https://readdy.ai/api/search-image?query=green%20PPRC%20pipes%20for%20hot%20and%20cold%20water%20plumbing%2C%20professional%20product%20photography%20on%20white%20background%2C%20high%20quality%20plumbing%20materials%2C%20studio%20lighting&width=500&height=500&seq=prod19&orientation=squarish'
    },
    {
      category: 'pipes',
      name: 'Pipe Sockets & Elbows',
      description: 'Complete range of pipe fittings',
      features: ['Various angles', 'Strong joints', 'Easy installation'],
      image: 'https://readdy.ai/api/search-image?query=white%20PVC%20pipe%20fittings%20including%20sockets%20elbows%20and%20connectors%2C%20professional%20product%20photography%20on%20clean%20background%2C%20plumbing%20fittings%20accessories%2C%20studio%20lighting&width=500&height=500&seq=prod20&orientation=squarish'
    },
    {
      category: 'pipes',
      name: 'Pipe Tees & Connectors',
      description: 'T-joints and connectors for pipe systems',
      features: ['Multiple sizes', 'Leak-proof', 'High-quality material'],
      image: 'https://readdy.ai/api/search-image?query=white%20PVC%20pipe%20tee%20joints%20and%20connectors%20in%20various%20sizes%2C%20professional%20product%20photography%20on%20white%20background%2C%20plumbing%20fittings%2C%20studio%20lighting&width=500&height=500&seq=prod21&orientation=squarish'
    },
    {
      category: 'pipes',
      name: 'Pipe Adhesive & Sealant',
      description: 'Professional-grade pipe joining materials',
      features: ['Strong bonding', 'Waterproof', 'Quick-drying'],
      image: 'https://readdy.ai/api/search-image?query=PVC%20pipe%20adhesive%20glue%20and%20sealant%20tubes%2C%20professional%20product%20photography%20on%20white%20background%2C%20plumbing%20installation%20materials%2C%20studio%20lighting&width=500&height=500&seq=prod22&orientation=squarish'
    },
    {
      category: 'pipes',
      name: 'Complete Fittings Kit',
      description: 'All-in-one pipe fittings package',
      features: ['Complete set', 'All sizes included', 'Professional grade'],
      image: 'https://readdy.ai/api/search-image?query=complete%20set%20of%20white%20PVC%20pipe%20fittings%20and%20accessories%20organized%20neatly%2C%20professional%20product%20photography%20on%20clean%20background%2C%20plumbing%20installation%20kit%2C%20studio%20lighting&width=500&height=500&seq=prod23&orientation=squarish'
    },

    // Hardware Tools
    {
      category: 'hardware',
      name: 'Work Gloves Set',
      description: 'Durable work gloves for plumbing and construction',
      features: ['Comfortable fit', 'Durable material', 'Good grip'],
      image: 'https://readdy.ai/api/search-image?query=professional%20work%20gloves%20for%20construction%20and%20plumbing%2C%20professional%20product%20photography%20on%20white%20background%2C%20safety%20work%20gloves%2C%20studio%20lighting&width=500&height=500&seq=prod24&orientation=squarish'
    },
    {
      category: 'hardware',
      name: 'Teflon Tape Rolls',
      description: 'Thread seal tape for pipe fittings',
      features: ['Leak prevention', 'Easy to use', 'Multiple rolls'],
      image: 'https://readdy.ai/api/search-image?query=white%20teflon%20tape%20rolls%20for%20plumbing%20thread%20sealing%2C%20professional%20product%20photography%20on%20clean%20background%2C%20plumbing%20supplies%2C%20studio%20lighting&width=500&height=500&seq=prod25&orientation=squarish'
    },
    {
      category: 'hardware',
      name: 'Adjustable Wrench Set',
      description: 'Professional adjustable wrenches',
      features: ['Multiple sizes', 'Chrome-plated', 'Durable construction'],
      image: 'https://readdy.ai/api/search-image?query=chrome%20adjustable%20wrenches%20in%20different%20sizes%2C%20professional%20product%20photography%20on%20white%20background%2C%20plumbing%20tools%2C%20studio%20lighting&width=500&height=500&seq=prod26&orientation=squarish'
    },
    {
      category: 'hardware',
      name: 'Pliers Set',
      description: 'Complete set of pliers for plumbing work',
      features: ['Various types', 'Comfortable grip', 'Professional quality'],
      image: 'https://readdy.ai/api/search-image?query=professional%20pliers%20set%20for%20plumbing%20work%2C%20professional%20product%20photography%20on%20white%20background%2C%20hand%20tools%2C%20studio%20lighting&width=500&height=500&seq=prod27&orientation=squarish'
    },
    {
      category: 'hardware',
      name: 'Pipe Cutter Tool',
      description: 'Professional pipe cutting tool',
      features: ['Clean cuts', 'Easy to use', 'Durable blade'],
      image: 'https://readdy.ai/api/search-image?query=professional%20pipe%20cutter%20tool%20for%20PVC%20and%20PPRC%20pipes%2C%20professional%20product%20photography%20on%20white%20background%2C%20plumbing%20cutting%20tool%2C%20studio%20lighting&width=500&height=500&seq=prod28&orientation=squarish'
    },
    {
      category: 'hardware',
      name: 'Complete Tool Kit',
      description: 'All essential plumbing and hardware tools',
      features: ['Complete set', 'Professional grade', 'Organized case'],
      image: 'https://readdy.ai/api/search-image?query=complete%20plumbing%20tool%20kit%20with%20wrenches%20pliers%20and%20accessories%20in%20organized%20case%2C%20professional%20product%20photography%20on%20white%20background%2C%20professional%20tools%20set%2C%20studio%20lighting&width=500&height=500&seq=prod29&orientation=squarish'
    }
  ];

  const filteredProducts = selectedCategory === 'all' 
    ? products 
    : products.filter(p => p.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <WhatsAppButton />

      {/* Hero Section */}
      <section className="bg-gradient-to-r from-orange-600 to-orange-500 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-6">Our Products</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Explore our comprehensive range of premium sanitary ware, kitchen fixtures, pipes, and hardware tools
          </p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-12 bg-gray-50 sticky top-0 z-10 shadow-md">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setSelectedCategory(cat.id)}
                className={`px-6 py-3 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer flex items-center gap-2 ${
                  selectedCategory === cat.id
                    ? 'bg-orange-600 text-white shadow-lg'
                    : 'bg-white text-gray-700 hover:bg-orange-50 border-2 border-gray-200'
                }`}
              >
                <i className={`${cat.icon} text-xl`}></i>
                {cat.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProducts.map((product, index) => (
              <div 
                key={index} 
                className="bg-white rounded-xl shadow-md hover:shadow-2xl transition-all overflow-hidden group border-2 border-gray-100"
                data-product-shop
              >
                <div className="overflow-hidden">
                  <img 
                    src={product.image} 
                    alt={product.name}
                    className="w-full h-72 object-cover object-top group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-800">{product.name}</h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">{product.description}</p>
                  <div className="mb-6">
                    <h4 className="font-semibold text-gray-800 mb-2">Key Features:</h4>
                    <ul className="space-y-1">
                      {product.features.map((feature, idx) => (
                        <li key={idx} className="text-sm text-gray-600 flex items-start gap-2">
                          <i className="ri-check-line text-orange-600 mt-0.5"></i>
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <a 
                    href="https://wa.me/923135224547" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="block w-full bg-orange-600 hover:bg-orange-700 text-white text-center py-3 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-whatsapp-line mr-2"></i>
                    Call for Price
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-orange-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-6">Need Help Choosing?</h2>
          <p className="text-xl mb-10 max-w-2xl mx-auto">
            Our expert team is ready to help you select the perfect products for your needs
          </p>
          <a 
            href="https://wa.me/923135224547" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-white hover:bg-gray-100 text-orange-600 px-10 py-4 rounded-lg text-lg font-semibold transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            Contact Us on WhatsApp
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
